import { apiSlice } from "../../apiSlice";

export const ventasxxApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    CreateVentas: builder.mutation({
      query: (parameters) => ({
        url: `/Ventasxx/Ventasxx`,
        method: "POST",
        body: parameters,
      }),
    }),
    UpdateVentas: builder.mutation({
      query: (parameters) => ({
        url: `/Ventasxx/Ventasxx/${parameters.vtcaidxx}/${parameters.sYear}`,
        method: "PUT",
        body: parameters,
      }),
    }),
    SearchCotizaId: builder.mutation({
      query: (parameters) => ({
        url: `/Ventasxx/Ventasxx/${parameters.idCotizacion}/${parameters.sYear}`,
        method: "GET",
      }),
    }),
    CotiDocs: builder.mutation({
      query: (parameters) => ({
        url: `/Ventasxx/Ventasxx/CotiDocs`,
        method: "POST",
        body: parameters,
      }),
    }),
    Qtacepta: builder.mutation({
      query: (parameters) => ({
        url: `/Ventasxx/Ventasxx/Qtacepta/${parameters.sYear}`,
        method: "POST",
        body: parameters.newFormData,
      }),
    }),
    SearchTbCargos: builder.mutation({
      query: (parameters) => ({
        url: `/Ventasxx/Ventasxx/TbCargos/${parameters.idCotizacion}/${parameters.sYear}`,
        method: "GET",
      }),
    }),
    CalculoVacobven: builder.mutation({
      query: (parameters) => ({
        url: `/Ventasxx/Ventasxx/Vacobven`,
        method: "POST",
        body: parameters,
      }),
    }),
    CalculoIvacalcx: builder.mutation({
      query: (parameters) => ({
        url: `/Ventasxx/Ventasxx/Ivacalcx`,
        method: "POST",
        body: parameters,
      }),
    }),
    SaveChargesx: builder.mutation({
      query: (parameters) => ({
        url: `/Ventasxx/Chargevt/${parameters.sYear}`,
        method: "POST",
        body: parameters,
      }),
    }),
    getItemsCargos: builder.mutation({
      query: ({ sYear, filtersJson }) => ({
        url: `/Ventasxx/Chargevt/${sYear}`,
        method: "GET",
        params: { filtersJson },
      }),
    }),
    InactiveChargesx: builder.mutation({
      query: ({sYear,chidxxxx}) => ({
        url: `/Ventasxx/Chargevt/${chidxxxx}/${sYear}`,
        method: "DELETE",
      }),
    }),
    SaveTotalcon: builder.mutation({
      query: (parameters) => ({
        url: `/Ventasxx/ConTotal/${parameters.sYear}`,
        method: "POST",
        body: parameters,
      }),
    }),
    UpdateTotalcon: builder.mutation({
      query: (parameters) => ({
        url: `/Ventasxx/ConTotal/${parameters.vtcaidxx}/${parameters.sYear}`,
        method: "PUT",
        body: parameters,
      }),
    }),
    getItemsConTotal: builder.mutation({
      query: ({ sYear, filtersJson }) => ({
        url: `/Ventasxx/ConTotal/${sYear}`,
        method: "GET",
        params: { filtersJson },
      }),
    }),
    GeneratePdf: builder.mutation({
      query: (parameters) => ({
        url: `/Ventasxx/Ventasxx/Qtgenpdf/${parameters.sYear}`,
        method: "POST",
        body: parameters,
      }),
    }),
    SaveDataEmail: builder.mutation({
      query: (parameters) => ({
        url: `/Ventasxx/Ventasxx/Qtsendma/${parameters.sYear}`,
        method: "POST",
        body: parameters,
      }),
    }),
    SaveDataQtnotesx: builder.mutation({
      query: (parameters) => ({
        url: `/Ventasxx/Ventasxx/Qtnotesx/${parameters.sYear}`,
        method: "POST",
        body: parameters,
      }),
    }),
    SearchVaricove: builder.mutation({
      query: (parameters) => ({
        url: `/Ventasxx/Ventasxx/Varicove/${parameters.idCotizacion}/${parameters.sYear}`,
        method: "GET",
      }),
    }),
    SaveDesist: builder.mutation({
      query: (parameters) => ({
        url: `/Ventasxx/Ventasxx/Qtclause`,
        method: "POST",
        body: 
          parameters,
        
      }),
    }),
  }),
});

export const {
  useCreateVentasMutation,
  useUpdateVentasMutation,
  useSearchCotizaIdMutation,
  useCotiDocsMutation,
  useQtaceptaMutation,
  useSearchTbCargosMutation,
  useCalculoVacobvenMutation,
  useCalculoIvacalcxMutation,
  useSaveChargesxMutation,
  useGetItemsCargosMutation,
  useSaveTotalconMutation,
  useUpdateTotalconMutation,
  useGetItemsConTotalMutation,
  useInactiveChargesxMutation,
  useGeneratePdfMutation,
  useSaveDataEmailMutation,
  useSaveDataQtnotesxMutation,
  useSearchVaricoveMutation,
  useSaveDesistMutation,
} = ventasxxApiSlice;
